import React from "react";
import { Accordion, AccordionPanel } from "@dtci/spellbook/Accordion";
import { usePPTState } from "tap/store/ppt/usePPT";
import { PPTSeverityBadge } from "../PPTSeverityBadge";
import styles from "./styles.module.scss";

export const PPTDiscountIssuesList = () => {
  const { discountIssues, discountDetailsLoading } = usePPTState();

  if (discountDetailsLoading) {
    return null;
  }

  if (!discountIssues || discountIssues.issueCount === 0) {
    return (
      <div className={styles.empty}>No issues found for this discount</div>
    );
  }

  const { maxSeverity, byType = [], issueCount } = discountIssues;

  return (
    <section
      className={`${styles.issuesSection} ${
        maxSeverity
          ? styles[`background-${maxSeverity.toLowerCase()}`]
          : styles["background-info"]
      }`}
    >
      <h4 className={styles.sectionTitle}>Issues ({issueCount})</h4>
      <Accordion allowMultipleOpen className={styles.accordion}>
        {byType.map((issueType) => {
          const typeToggleBar = (
            <div className={styles.panelLabel}>
              <PPTSeverityBadge severity={issueType.severity} />
              <span>{issueType.summary}</span>
            </div>
          );

          return (
            <AccordionPanel
              key={issueType.issueType}
              panelId={issueType.issueType}
              toggleBar={typeToggleBar}
              className={styles.typePanel}
            >
              <ul className={styles.issuesList}>
                {issueType.issues.map((issue) => (
                  <li key={issue.id} className={styles.issue}>
                    <PPTSeverityBadge severity={issue.severity} />
                    <div className={styles.issueDescription}>
                      {issue.description}
                    </div>
                  </li>
                ))}
              </ul>
            </AccordionPanel>
          );
        })}
      </Accordion>
    </section>
  );
};
